import React, { useEffect } from 'react';
import { ReviewsHero } from './reviews/ReviewsHero';
import { ReviewsGrid } from './reviews/ReviewsGrid';
import { ReviewsFinalCTA } from './reviews/ReviewsFinalCTA';
export function Reviews() {
  useEffect(() => {
    document.title = 'Reviews | Storm Taekwondo';
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-2921">
      <ReviewsHero data-id="element-2922" />
      <ReviewsGrid data-id="element-2923" />
      <ReviewsFinalCTA data-id="element-2924" />
    </div>;
}